import { FirmaDto } from "../../../../interfaces/schema";
import { defaultIfNullish } from "../../../../util/stringUtil";
import ListItem from "../../../ListItem";
import { SidebarContainer } from "../../../SidebarContainer";

export default function Sidebar(props: { firma: FirmaDto }) {
  const { firma } = props;
  return (
    <SidebarContainer>
      <ListItem label="Firmanummer" value={defaultIfNullish(firma.firmaNr)} />
      <ListItem label="Status" value={firma.aktiv ? "Aktiv" : "Inaktiv"} />
      <ListItem
        label="Advokatvirksomhed"
        value={firma.advokatVirksomhed ? "Ja" : "Nej"}
      />
      <ListItem
        label="By"
        value={defaultIfNullish(firma.kommuneNavigation?.navn)}
      />
    </SidebarContainer>
  );
}
